import { flexPropDefs, paddingPropDefs, buttonPropDefs } from '@radix-ui/themes/props';
import _omit from 'lodash.omit';
import { semanticColorValues } from '../../utils/semantic-color.js';
export const sideNavigationRootPropDefs = {
    defaultExpanded: {
        type: 'boolean',
        default: true,
    },
    expanded: {
        type: 'boolean',
    },
    onExpandedChange: {
        type: 'function',
    },
    children: {
        type: 'ReactNode[] | ReactNode',
        required: true,
    },
};
export const sideNavigationContentPropDefs = {
    display: {
        ..._omit(flexPropDefs.display, 'className'),
        default: 'flex',
    },
    direction: {
        ..._omit(flexPropDefs.direction, 'className'),
        default: 'column',
    },
    gapY: {
        ...flexPropDefs.gapY,
        default: '5',
    },
    p: {
        ...paddingPropDefs.p,
        default: '2',
    },
    expandedWidth: {
        type: 'string',
        default: '264px',
    },
    collapsedWidth: {
        type: 'string',
        default: '48px',
    },
};
export const sideNavigationHeaderPropDefs = {
    align: {
        ..._omit(flexPropDefs.align, 'className'),
        default: 'center',
    },
    gapY: {
        ...flexPropDefs.gapY,
        default: '4',
    },
};
export const sideNavigationExpandPropDefs = {
    display: {
        ..._omit(flexPropDefs.display, 'className'),
        default: 'flex',
    },
    align: {
        ..._omit(flexPropDefs.align, 'className'),
        default: 'center',
    },
    gapX: {
        ...flexPropDefs.gapX,
        default: '2',
    },
};
export const sideNavigationItemsPropDefs = {
    display: {
        ..._omit(flexPropDefs.display, 'className'),
        default: 'flex',
    },
    direction: {
        ..._omit(flexPropDefs.direction, 'className'),
        default: 'column',
    },
    gapY: {
        ...flexPropDefs.gapY,
        default: '1',
    },
    side: {
        type: 'enum',
        values: ['top', 'bottom'],
        default: 'top',
    },
};
export const sideNavigationItemPropDefs = {
    variant: {
        ...buttonPropDefs.variant,
        default: 'soft',
    },
    icon: {
        type: 'ReactNode',
    },
    active: {
        type: 'boolean',
        default: false,
    },
};
const sideNavigationGroupColorValues = [
    ...buttonPropDefs.color.values,
    ...semanticColorValues,
];
export const sideNavigationGroupPropDefs = {
    display: {
        ..._omit(flexPropDefs.display, 'className'),
        default: 'flex',
    },
    direction: {
        ..._omit(flexPropDefs.direction, 'className'),
        default: 'column',
    },
    gapY: {
        type: 'string',
        default: '1',
    },
    icon: {
        type: 'ReactNode',
        required: true,
    },
    pl: {
        type: 'string',
        default: '5',
    },
    label: {
        type: 'string',
        required: true,
    },
    color: {
        ...buttonPropDefs.color,
        values: sideNavigationGroupColorValues,
        default: 'gray',
    },
    defaultOpen: {
        type: 'boolean',
        default: false,
    },
};
export const sideNavigationGroupItemPropDefs = {
    variant: {
        ...buttonPropDefs.variant,
        default: 'soft',
    },
    active: {
        type: 'boolean',
        default: false,
    },
};
//# sourceMappingURL=side-navigation.props.js.map